export const Icon = () => {
	return <svg width="36" height="36" viewBox="0 0 36 36" fill="#FFFFFE">
		<path d="M22.4043 19.1719L22.9172 15.913H19.7576V13.7946C19.7576 12.9035 20.1987 12.0328 21.6092 12.0328H23.066V9.25754C22.2176 9.12226 21.3604 9.04907 20.5013 9.03857C17.9008 9.03857 16.203 10.6019 16.203 13.428V15.913H13.3203V19.1719H16.203V27.0546H19.7576V19.1719H22.4043Z" />
		</svg>
}